import type { FunctionComponent, PropsWithChildren } from 'react';
import { useState } from 'react';
import FocusLock from 'react-focus-lock';

import Portal from '@atlaskit/portal';
import { Key, Scope, useShortcut } from '@trello/keybindings';
import {
  ELEVATION_ATTR,
  getHighestVisibleElevation,
} from '@trello/layer-manager';

import * as styles from './AttachmentViewerContainer.module.less';

interface AttachmentViewerContainerProps {
  onClose: () => void;
}

export const AttachmentViewerContainer: FunctionComponent<
  PropsWithChildren<AttachmentViewerContainerProps>
> = ({ onClose, children }) => {
  const [elevation] = useState(() => getHighestVisibleElevation() + 1);

  useShortcut(onClose, { scope: Scope.Overlay, key: Key.Escape });

  return (
    <Portal zIndex={1}>
      <FocusLock autoFocus={true} returnFocus={true}>
        <div className={styles.container} {...{ [ELEVATION_ATTR]: elevation }}>
          {children}
        </div>
      </FocusLock>
    </Portal>
  );
};
